// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { genericTelemetryClickDispatcher } from "@msnews/social-utils";
export interface UserCardTelemetryObjects {
    userCardNameLink: TelemetryObjectBase;
    userCardAvatarLink: TelemetryObjectBase;
}
export const userCardTelemetryContracts = {
    /** Scenario 2 click profile name
     * id: traceId
     * headline: username
    */
    userCardProfileLink: {
        name: "Profile",
        behavior: TelemetryBehaviorType.Navigate,
        content: {
            type: TelemetryContentType.Comment
        }
    }
};

export const userCardTelemetryActionDispatchers = {
    genericClick: genericTelemetryClickDispatcher
};